(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["geo-store-switcher"] && !Shopify.designMode) return;
  try {
    (() => {
    const dialog = document.querySelector('[data-geo-store-switcher]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    const region = dialog.dataset.currentRegion;
    const storageKey = `cocoleni-store-choice-${region}`;

    try {
      if (sessionStorage.getItem(storageKey)) return;
    } catch (error) {}

    const rememberChoice = () => {
      try {
        sessionStorage.setItem(storageKey, 'true');
      } catch (error) {}
    };

    const closeDialog = () => {
      rememberChoice();
      dialog.close();
    };

    dialog.querySelector('[data-geo-store-close]')?.addEventListener('click', closeDialog);
    dialog.querySelector('[data-geo-store-stay]')?.addEventListener('click', closeDialog);
    dialog.addEventListener('cancel', rememberChoice);

    const switchLink = dialog.querySelector('[data-geo-store-switch]');
    const targetUrl = new URL(window.location.pathname, dialog.dataset.targetOrigin);
    targetUrl.hash = window.location.hash;
    switchLink.href = targetUrl.toString();
    switchLink.addEventListener('click', rememberChoice);

    const showForCountry = (countryCode, countryName) => {
      if (!countryCode) return;

      const isIndia = countryCode.toUpperCase() === 'IN';
      const isMismatch = region === 'india' ? !isIndia : isIndia;
      if (!isMismatch) return;

      const message = dialog.dataset.countryMessage.replace('__COUNTRY__', countryName || countryCode);
      dialog.querySelector('[data-geo-store-message]').textContent = message;
      dialog.showModal();
    };

    const root = window.Shopify?.routes?.root || '/';
    const suggestionUrl = `${root}browsing_context_suggestions.json?country[enabled]=true`;

    fetch(suggestionUrl, { credentials: 'same-origin' })
      .then((response) => response.ok ? response.json() : Promise.reject())
      .then((data) => {
        const country = data?.detected_values?.country;
        showForCountry(country?.handle, country?.name);
      })
      .catch(() => showForCountry(dialog.dataset.activeCountry, dialog.dataset.activeCountry));
  })();
  } catch(e) { console.error(e); }
})();

})();
